const STORE_ID = 'INSTITUICAO_FINANCEIRA'

const TYPES = {
    SET_INSTITUICOES_FINANCEIRAS_COD_W3ERP: 'SET_INSTITUICOES_FINANCEIRAS',
    CLEAN_INSTITUICOES_FINANCEIRAS_COD_W3ERP: 'CLEAN_INSTITUICOES_FINANCEIRAS_COD_W3ERP'
}

export { STORE_ID, TYPES }